import React,{useEffect,useState} from "react";
import { useLocation } from 'react-router-dom';
import {Box,Paper, TextField, MenuItem, Grid, Typography,Card,CardMedia } from "@mui/material";
import apiClient from "./api/apiClient";
import NewCheckDetailsFormRenderer from "./NewCheckDetailsFormRenderer";

const CheckDetailsNewComponent = ()=> {
    const [formData, setFormData] = useState(null);
    const[loading,setLoading] =useState(true);
    const location = useLocation();
    const { caseId, checkId, checkType } = location.state || {};
    const [photoUrls, setPhotoUrls] = useState([]);
    const [photoIsLoading, setPhotoIsLoading] = useState(true);
    const [candidateName,setCandidateName] = useState("");
    const [clientName,setClientName] = useState("");
    const [status,setStatus] = useState("");
    const [fieldComments,setFieldComments] = useState("");
    const [colorCode,setColorCode] = useState("");
    useEffect(() => {
        fetchCheckDetails();
        fetchPhotos();
       // Replace with your actual endpoint

      }, []);
    const fetchCheckDetails = async()=>{
      try{
        let response = await apiClient.get(`/checks/${caseId}/${checkType}/${checkId}`)
        console.log("fields is ",response.data.fields);
        console.log("Form Data being set")
        setFormData(JSON.parse(response.data.fields));
        setCandidateName(response.data.candidateName);
        setClientName(response.data.clientName);
        setStatus(response.data.status);
        setFieldComments(response.data.fieldComments);
        setColorCode(response.data.colorCode);
        console.log("Form Data set");
      }
      catch(error){
        console.error("Failed to fetch form data:", error);
      }finally{
        setLoading(false);
      }
    }  
    const fetchPhotos = async () => {
      try {
//        const { caseId, checkType, checkId } = lhsDetails; // Assuming checkType & checkId are in lhsDetails
        const response = await apiClient.get(
          `/checks/photographs/${caseId}/${checkType}/${checkId}`
        );
        console.log("Response with phtotographs is ",response);
//        const data = await response.json(); // e.g., ["url1.jpg", "url2.jpg"]
        setPhotoUrls(response.data);
      } catch (err) {
        console.error("Error fetching photos:", err);
      }finally{
        setPhotoIsLoading(false);
      }    
    }
    return (
      <>
        <Box p={3}>
          {/* CASE DETAILS */}
          <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              Case Details
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Case ID"
                  fullWidth
                  value={caseId}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Client Name"
                  fullWidth
                  value={clientName}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Candidate Name"
                  fullWidth
                  value={candidateName}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Status"
                  fullWidth
                  value={status}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Field Comments"
                  fullWidth
                  value={fieldComments}
                  InputProps={{ readOnly: true }}
                  multiline
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Color Code"
                  fullWidth
                  value={colorCode}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            </Grid>
          </Paper>
  
          {/* FORM FIELDS */}
          {!loading && <NewCheckDetailsFormRenderer data={formData} />}
  
          {/* PHOTOS */}
          <Box mt={4}>
            <Typography variant="h6" color="primary" gutterBottom>
              Photographs
            </Typography>
            <Grid container spacing={2}>
              {photoUrls.length > 0 ? (
                photoUrls.map((url, idx) => (
                  <Grid item xs={12} sm={6} md={3} key={idx}>
                    <Card>
                      <CardMedia
                        component="img"
                        height="180"
                        image={`data:image/jpeg;base64,${url}`}
                        alt={`Photo ${idx + 1}`}
                      />
                    </Card>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <Typography>No photographs available.</Typography>
                </Grid>
              )}
            </Grid>
          </Box>
        </Box>
      </>
    );
}
export default CheckDetailsNewComponent;